import React, { useState } from "react";
import { Sms, CloseCircle, Eye, EyeSlash, ArrowLeft } from "iconsax-react";
import { GoLock } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import ProgressBar from "@ramonak/react-progress-bar";
import { LSSB, setUserData } from "../utils/LSSB_live";
import { ClipLoader } from "react-spinners";
import { enqueueSnackbar } from "notistack";

const ForgotPassword = () => {
  const navigate = useNavigate();
 
  const [email, setEmail] = useState("");

  const [isLoading, setIsLoading] = useState(false);


  const handleresetPass = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      let res = await LSSB.make_API_call({
        _endpoint: 'initiate_reset_password',
    email: email,
      });
      if(res?.success == true){
       
        enqueueSnackbar(res?.data?.msg, { variant: "success" });
  
        navigate("/reset-password",{state: email} );
        setIsLoading(false);

      }else{
           enqueueSnackbar(res?.error?.msg, { variant: "error" });
        setIsLoading(false);

      }
     
    } catch (e) {
      console.log("errrorrrr====>..",e);
    }
   
  };
  return (
    <div className="h-screen md:h-[850px] w-full flex items-center ">
    <div className="h-full w-[20%] md:w-[50%] relative hidden md:block">
      {" "}
      <img
        src="./asset/lssbImage.png"
        alt=""
        className="object-cover h-full w-full -z-10"
      />
      <div className="flex gap-[16px] items-center absolute z-10 top-[24px] left-[24px] md:top-[48px] md:left-[48px]">
        <img
          src="./asset/lssbLogo.png"
          alt="logo"
          className="h-[40px] w-[40px] md:h-[58px] md:w-[58px]"
        />
        <div>
          <p className="text-sm  md:text-base text-white font-medium md:font-semibold leading-[20px]">
            Lagos State
          </p>
          <p className="text-sm  md:text-base text-white font-medium md:font-semibold leading-[20px]">
            Scholarship Board
          </p>
        </div>
      </div>
    </div>
    <div className="h-full w-full md:w-[50%] bg-[#ffff] flex justify-center items-center relative">
    <Link to="/login" className="absolute right-3 top-3">
                {" "}
                <button className=""><ArrowLeft color="#7C8493"/></button>
              </Link>
      <div className="md:hidden flex gap-[16px] items-center absolute z-10 top-[24px] left-[24px] md:top-[48px] md:left-[48px]">
        <img
          src="./asset/lssbLogo.png"
          alt="logo"
          className="h-[40px] w-[40px] md:h-[58px] md:w-[58px]"
        />
        <div>
          <p className="text-sm  md:text-base text-[#7C8493] font-medium md:font-semibold leading-[20px]">
            Lagos State
          </p>
          <p className="text-sm  md:text-base text-[#7C8493] font-medium md:font-semibold leading-[20px]">
            Scholarship Board
          </p>
        </div>
      </div>

      <div className="bg-[#ffff] rounded-[16px] w-[330px] max-w-[320px] md:w-[408px] md:max-w-[409px] pt-[24px] md:pt-[32px]  pb-[24px] ">
        <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-3">
          Forgot Password
        </h2>
        <p className="text-[14px] md:text-[16px] text-[#515B6F] leading-[20px] mb-[20px] md:mb-[30px] xl:mb-[50px]">
            Enter your registered email address to
            receive a password reset link.
        </p>

        <form onSubmit={handleresetPass} className=" w-full">
          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
             
              Enter Email
            </label>
            <div className=" ">
              <input
                type="text"
                placeholder="Enter email address"
                className="w-full h-[50px] px-[16px] py-[12px] text-[14px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                autoComplete="on"
                  
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              />
            </div>
          </div>

         

          <button
            type="submit"
            className="w-full py-[14px] text-center text-white bg-[#AF8544]  flex items-center justify-center mb-[20px] md:mb-[32px]"
          >
            <p className="text-sm font-medium leading-[20px]">Continue</p>{" "}
            {isLoading && <ClipLoader color={"white"} size={20} />}
          </button>

         
        </form>
      </div>
    </div>
  </div>
);
  
}

export default ForgotPassword